var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineIntegratedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-bolt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.548 18.2232H9.67607L10.548 12.12H7.49636C6.99066 12.12 6.99938 11.841 7.16504 11.5446C7.3307 11.2482 7.20863 11.4748 7.22607 11.44C8.35081 9.45207 10.0423 6.48766 12.2917 2.5293H13.1636L12.2917 8.6325H15.3433C15.7706 8.6325 15.8316 8.92022 15.7531 9.07716L15.6921 9.20794C12.2569 15.2152 10.548 18.2232 10.548 18.2232Z",
    fill: "url(#paint0_linear_4189_1217)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4189_1217",
    x1: 2.70439,
    y1: 10.3763,
    x2: 16.0293,
    y2: 17.7788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7928CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIntegratedicon);
export default __webpack_public_path__ + "static/media/timeline-integratedicon.3cc0159a88ffa4c20375d9b27e25d9be.svg";
export { ForwardRef as ReactComponent };